
<div class="statemap" *ngIf="pluginManager && pluginManager.appController && pluginManager.appController.showDebug">
    <fa-icon icon="circle" [class.selected]="context.state.sm.is('blank')" [class.ishidden]="context.state.sm.is('blank') && context.config.showWhenBlank"></fa-icon>
    <fa-icon icon="question-circle" [class.selected]="context.state.sm.is('setup')"></fa-icon>
    <fa-icon icon="arrow-circle-right" [class.selected]="context.state.sm.is('queued')"></fa-icon>
    <fa-icon icon="spinner" [class.selected]="context.state.sm.is('processing')"></fa-icon>
    <fa-icon icon="exclamation-circle" [class.selected]="context.state.sm.is('failed')"></fa-icon>
    <fa-icon icon="times-circle" [class.selected]="context.state.sm.is('aborted')"></fa-icon>
    <fa-icon icon="check-circle" [class.selected]="context.state.sm.is('succeeded')"></fa-icon>
    <fa-icon icon="power-off" [class.selected]="context.state.sm.is('ending')"></fa-icon>

    <i style="background-color:orange;color:#fff;padding:1px 5px 3px 5px;margin-left:10px;border-radius:3px;box-shadow: 0 0 4px rgba(0,0,0,.3);">{{ context.state.state }}</i>

    <b class="float-right fdm-link" [title]="context.label+' ['+context.uid+']'" (click)="context['_panel'] = !context['_panel']">
        {{ context.type }}
        <fa-icon icon="chevron-down" *ngIf="!context['_panel']" class="fdm-link"></fa-icon>
        <fa-icon icon="chevron-up" *ngIf="context['_panel']" class="fdm-link"></fa-icon>
    </b>

    <div class="canvas" [@slideInOut] *ngIf="context['_panel']"> 
        <div class="header fdm-link" [class.selected]="isVisible('header')" (click)="context.visual.state = ! context.visual.state">
            header (visual state: {{ context.visual.state ? 'SHOW' : 'HIDE' }})
            <fa-icon icon="chevron-circle-down" *ngIf="!context.visual.state" class="fdm-icon-taskbar fdm-link float-right"></fa-icon>
            <fa-icon icon="chevron-circle-up" *ngIf="context.visual.state" class="fdm-icon-taskbar fdm-link float-right"></fa-icon>
            <div class="clearfix"></div>
        </div>
        <div class="menu" [class.selected]="isVisible('menu')">menu</div>
        <div class="path" [class.selected]="isVisible('path')">path</div>
        <div class="content" [class.selected]="isVisible('content')">
            <div>
                transitions: <span *ngFor="let t of context.state.sm.transitions()" (click)="context.state[t]()">{{ t }}</span>
            </div>
        </div>
        <div class="footer" [class.selected]="isVisible('footer')">footer</div>
        <textarea style="width:100%;height:100px;font-size:8px;">{{ context.props['panels'] | json }}</textarea>
    </div>
</div>



<div [@slideInOut] [class]="'fdm-workflow-panel ' + context.type +' ' + context.category" *ngIf="!context.state.sm.is('blank')">

    <div *ngIf="isVisible('header')" class="header">

        <fa-icon icon="window-close" (click)="parent.removeApp(context)" *ngIf="parent && context.config.canDelete" class="fdm-icon-taskbar fdm-link float-right"></fa-icon>
        
        <span *ngIf="context.config.canShowHide" (click)="context.visual.state = ! context.visual.state">
            <fa-icon icon="chevron-circle-down" *ngIf="!context.visual.state" class="fdm-icon-taskbar fdm-link float-right"></fa-icon>
            <fa-icon icon="chevron-circle-up" *ngIf="context.visual.state" class="fdm-icon-taskbar fdm-link float-right"></fa-icon>
        </span>

        <fa-icon *ngIf="context.props.icon" [icon]="context.props.icon" class="fdm-icon"></fa-icon>
        {{ context.props.label }}

    </div>

    <div [@slideInOut] *ngIf="isVisible('menu') && hasMenuItems()" class="menu">
        menu
    </div>

    <div [@slideInOut] *ngIf="isVisible('path')" class="path">
        p <fdm-workflow-items *ngIf="hasItems('path')" [type]="'path'" [context]="context"></fdm-workflow-items>
    </div>

    <div class="content" [@slideInOut] *ngIf="isVisible('content')">
        <fdm-workflow-items *ngIf="hasItems('content')" [type]="'content'" [context]="context"></fdm-workflow-items>

        <div *ngIf="context.product">
            PRODUCT 
            <textarea style="width:100%;height:80px;font-size:8px;">{{ context.product | json }}</textarea>
        </div>
        <!--
        <span *ngIf="context.state.sm.can('queue')" (click)="context.state.queue()"><fa-icon class="fdm-icon-thin" icon="play"></fa-icon></span>
        <span *ngIf="context.state.sm.is('queued') || context.state.sm.is('processing')" (click)="context.state.processAborted()"><fa-icon class="fdm-icon-thin" icon="stop"></fa-icon></span>
    
        <div *ngIf="context.product">
            <span (click)="context.product = null"><fa-icon class="fdm-icon-thin" icon="trash"></fa-icon></span>
            <textarea style="width:100%;height:80px;font-size:9px;">{{ context.product | json }}</textarea>
        </div>
    -->
        <!-- <textarea style="width:100%;height:80px;font-size:8px;">{{ context.config | json }}</textarea> -->
    </div>

    <div [@slideInOut] *ngIf="isVisible('footer')" class="footer">
        f <fdm-workflow-items *ngIf="hasItems('footer')" [type]="'footer'" [context]="context"></fdm-workflow-items>
    </div>

    <div class="children" *ngIf="context.processes && context.processes.length">
        <ng-container *ngFor="let process of context.processes; let idx = index;">
            <fdm-workflow-panel [context]="process" [parent]="context" [idx]="idx"></fdm-workflow-panel>
        </ng-container>
    </div>

    <!-- <textarea style="width:100%;height:80px;font-size:8px;">{{ context.config | json }}</textarea> -->

</div>

<!-- <textarea style="width:100%;height:280px;font-size:8px;background-color:#ddd;">{{ context | json }}</textarea> -->
